import { MenuItem, styled } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  height: theme.spacing(7),
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  '& .MuiListItemIcon-root': {
    justifyContent: 'center',
  },
  '&:hover': {
    backgroundColor: theme.palette.grey[800],
  },
}));
